var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55549 17.035C13.7183 17.035 17.0929 13.6604 17.0929 9.49762C17.0929 5.33482 13.7183 1.96021 9.55549 1.96021C5.39268 1.96021 2.01807 5.33482 2.01807 9.49762C2.01807 13.6604 5.39268 17.035 9.55549 17.035Z",
    stroke: "#B6B6B6",
    strokeWidth: 1.58683,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8861 17.8283L16.2993 16.2415",
    stroke: "#B6B6B6",
    strokeWidth: 1.58683,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNormal);
export default __webpack_public_path__ + "static/media/search-normal.b3c621994c4a9d556ac60bac5c31d206.svg";
export { ForwardRef as ReactComponent };